var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1892 38.6565C31.8456 34.5562 38.2847 31.853 41.5065 30.547C50.7055 26.818 52.617 26.1702 53.8628 26.1484C54.1368 26.1441 54.7495 26.2103 55.1464 26.5242C55.4815 26.7892 55.5737 27.1472 55.6178 27.3984C55.6619 27.6497 55.7169 28.2221 55.6732 28.6693C55.1747 33.774 53.0177 46.1619 51.9203 51.8793C51.4561 54.2985 50.5418 55.1097 49.6566 55.1891C47.733 55.3616 46.2724 53.9501 44.4093 52.7599C41.4939 50.8973 39.8469 49.7378 37.017 47.9204C33.7467 45.82 35.8667 44.6655 37.7305 42.7789C38.2182 42.2851 46.6936 34.7719 46.8577 34.0903C46.8782 34.005 46.8972 33.6873 46.7035 33.5195C46.5099 33.3517 46.224 33.4091 46.0177 33.4547C45.7254 33.5194 41.068 36.5196 32.0457 42.4553C30.7237 43.34 29.5263 43.771 28.4535 43.7484C27.2708 43.7235 24.9957 43.0966 23.3045 42.5609C21.2301 41.9037 19.5814 41.5562 19.7249 40.4401C19.7997 39.8587 20.6211 39.2643 22.1892 38.6565Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.e6e1a9832f19a4fe7115d624340569d3.svg";
export { ForwardRef as ReactComponent };